<template>
  <a
    class="checkbox"
    :class="{ active: active, disabled: disabled }"
    @click.prevent="check"
    :tabindex="disabled ? -1 : 0"
    v-on:keydown.space.prevent="check"
  >
    <div v-if="color" class="color-circle-container"><div class="color-circle" :style="{ backgroundColor: '#' + color }"></div></div>
    <div v-else-if="circle" class="check-circle-container">
      <div class="check-circle"><i v-if="active" class="af af-checkmark"></i><i v-if="!active" class="af af-circle"></i></div>
    </div>
    <div v-else class="check-square-container">
      <div class="check-square"><input type="checkbox" :checked="active" tabindex="-1" /></div>
    </div>
    <div class="title" v-if="title">{{ title }}</div>
  </a>
</template>
<script>
export default {
  components: {},

  props: {
    /**
     * The text description of the text box.
     */
    title: {
      type: String,
    },
    /**
     * @model
     * The checkbox value.
     */
    modelValue: {
      type: Boolean,
    },
    /**
     * Display the checkbox as a color toggle. Takes a hex color.
     */
    color: {
      type: String,
    },
    /**
     * Display the checkbox using the circle style.
     */
    circle: {
      type: Boolean,
      default: false,
    },
    /**
     * Boolean to enable or disable the checkbox.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      active: this.modelValue,
    };
  },

  created() {},

  methods: {
    check() {
      if (!this.disabled) {
        this.active = !this.active;
        /**
         * Input event for updating v-model value
         * @property {boolean} active value set when clicking on checkbox
         */
        this.$emit('update:modelValue', this.active);
      }
    },
  },

  computed: {},

  watch: {
    modelValue: {
      handler(value) {
        this.active = value;
      },
    },
  },
};
</script>
<style lang="postcss">
@import '@/pixel/style/variables';

/* purgecss start ignore */
.checkbox {
  display: flex;
  align-items: center;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  user-select: none;
  margin-top: 1px;
  margin-bottom: 1px;

  .title {
    background-color: var(--transparent);
    border-radius: var(--button-border-radius);
    padding-left: 8px;
    padding-right: 10px;
    line-height: 1.3em;
    transition: background-color 100ms ease-in-out, color 100ms ease-in-out;
  }

  .color-circle {
    width: 16px;
    height: 16px;
    border-radius: 15px;
    display: inline-block;
    border: 3px solid var(--white);
    transition: border-color 100ms ease-in-out, border 100ms ease-in-out;
  }

  /* purgecss ignore */
  &:hover:not(.disabled) {
    .color-circle {
      border: 3px solid var(--grey-ultra-light);
    }
  }

  .check-circle-container,
  .color-circle-container,
  .check-square-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: var(--circle-border-radius);
    border: 1px solid transparent;
    transition: background-color 200ms ease-out;
    box-sizing: border-box;
  }

  &[data-focus-visible-added]:not(:hover) {
    .check-circle-container,
    .color-circle-container,
    .check-square-container {
      background-color: var(--grey-ultra-light);
      border-color: var(--grey-light);
      box-shadow: 0px 0px 0px 1px var(--grey-light);
    }
  }

  /* purgecss ignore */
  &:hover {
    .check-circle-container,
    .color-circle-container,
    .check-square-container {
      background-color: var(--grey-ultra-light);
    }
  }

  .check-circle {
    border-radius: 15px;
    display: flex;
  }

  .check-square {
    line-height: 0;

    input[type='checkbox'] {
      pointer-events: none;
      position: static;
      margin: 0;
      padding: 0;
      margin-inline: 0;
      margin-block: 0;
    }
  }

  &.disabled {
    opacity: 0.3;
    cursor: auto;
    color: var(--link-color);

    .title {
      cursor: default;
    }
  }

  &.active {
    .title {
      color: var(--accent-color);
    }

    .color-circle {
      box-shadow: 0px 0px 0px 1px var(--accent-color);
    }
  }
}
/* purgecss end ignore */
</style>
